"use client"

import { cn } from "@/lib/utils"
import * as React from "react"

interface LoaderPulseProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "md" | "lg"
}

export function LoaderPulse({ 
  className, 
  size = "md",
  ...props 
}: LoaderPulseProps) {
  const sizeClasses = {
    sm: "h-2 w-2",
    md: "h-3 w-3",
    lg: "h-4 w-4",
  }

  return (
    <div 
      className={cn("relative flex items-center justify-center", className)}
      {...props}
    >
      <div 
        className={cn(
          "absolute inline-flex rounded-full opacity-75",
          "bg-primary/30",
          sizeClasses[size],
          "animate-ping"
        )} 
      />
      <div className={cn("rounded-full bg-primary/80", sizeClasses[size])} />
    </div>
  )
}
